<!--******************************************模态框提示--start**********************************************-->

<style lang="less" scoped>
    .showToast {
        padding: 0.2rem 0.8rem; border-radius: 0.1rem; background: #ffffff; color: #000000; font-size: 24px; display: flex;
    }
</style>

<template>
    <div class="showToast">{{content}}</div>
</template>

<script>
    export default {
        props: {
            content: null
        }
    };
</script>

<!--******************************************模态框提示--end**********************************************-->